/**
 * Safari and Private Browsing Compatible Storage Utilities
 */

// Detect if running in Safari
export const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1;
};

// Test if localStorage is available
const testLocalStorage = () => {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

// Test if IndexedDB is available
const testIndexedDB = () => {
  try {
    return !!window.indexedDB;
  } catch (e) {
    return false;
  }
};

// Memory storage fallback
let memoryStorage = {};

// Unified storage interface
export const storage = {
  canUseLocalStorage: testLocalStorage(),
  canUseIndexedDB: testIndexedDB(),
  
  setItem: (key, value) => {
    if (storage.canUseLocalStorage) {
      try {
        localStorage.setItem(key, value);
        return true;
      } catch (e) {
        console.warn('localStorage.setItem failed, using memory storage', e);
      }
    }
    // Fallback to memory
    memoryStorage[key] = value;
    return true;
  },
  
  getItem: (key) => {
    if (storage.canUseLocalStorage) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        console.warn('localStorage.getItem failed, checking memory storage', e);
      }
    }
    // Fallback to memory
    return memoryStorage[key] || null;
  },
  
  removeItem: (key) => {
    if (storage.canUseLocalStorage) {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        console.warn('localStorage.removeItem failed', e);
      }
    }
    delete memoryStorage[key];
  },
  
  clear: () => {
    if (storage.canUseLocalStorage) {
      try {
        localStorage.clear();
      } catch (e) {
        console.warn('localStorage.clear failed', e);
      }
    }
    memoryStorage = {};
  }
};

// Show warning if in Safari private mode or storage unavailable
export const checkStorageCompatibility = () => {
  if (!storage.canUseLocalStorage || !storage.canUseIndexedDB) {
    console.warn('⚠️ Storage limitations detected (Safari private mode?)');
    console.warn('- localStorage available:', storage.canUseLocalStorage);
    console.warn('- IndexedDB available:', storage.canUseIndexedDB);
    
    if (isSafari()) {
      console.warn('Safari detected - using fallback storage mechanisms');
    }
    
    return {
      isLimited: true,
      hasLocalStorage: storage.canUseLocalStorage,
      hasIndexedDB: storage.canUseIndexedDB,
      message: 'Funcionando con almacenamiento limitado. Algunos datos no se guardarán entre sesiones.'
    };
  }
  
  return {
    isLimited: false,
    hasLocalStorage: true,
    hasIndexedDB: true,
    message: null
  };
};
